import type { MenuProps } from 'antd';

type options = { 
  isGrouped: boolean;
};

export function getProductDotMenuItems({ isGrouped }: options): MenuProps['items'] {
  return [
    {
      label: isGrouped ? 'Delete group' : 'Grouped products',
      key: 'convert-to-group',
    },
  ];
}